import { useState } from 'react';
import { Sheet, SheetContent, SheetTitle } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { SubmitButton } from '@/components/ui/app/submit-button';
import { Building2, X } from 'lucide-react';
import FormSendToSubsidiaries, { FORM_SEND_TO_SUBSIDIARIES_ID } from '../forms/FormSendToSubsidiaries';
import { useTranslation } from 'react-i18next';

export default function SheetSendToSubsidiaries({ open, onClose, subsidiaries = [], onSubmit, isSubmitting = false }) {
    const { t } = useTranslation();
    const [resetKey, setResetKey] = useState(0);

    const handleOpenChange = (isOpen) => {
        if (!isOpen) {
            onClose();
            setResetKey((k) => k + 1);
        }
    };

    return (
        <Sheet open={open} onOpenChange={handleOpenChange}>
            <SheetContent
                showCloseButton={false}
                className="w-full md:w-[480px] flex flex-col p-0 overflow-hidden md:rounded-l-2xl"
            >
                {/* Header */}
                <div className="bg-card border-b border-border px-5 py-4 flex items-center justify-between shrink-0">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-lg bg-surface flex items-center justify-center">
                            <Building2 className="h-5 w-5 text-foreground" strokeWidth={1.5} />
                        </div>
                        <div>
                            <SheetTitle className="text-[16px] text-foreground font-medium">
                                {t('account:envoyerDesJetons')}
                            </SheetTitle>
                            <p className="text-[12px] text-muted-foreground">{t('account:auxSousComptes')}</p>
                        </div>
                    </div>
                    <Button
                        variant="plain"
                        color="neutral"
                        size="auto"
                        onClick={onClose}
                        className="w-10 h-10 rounded-lg bg-surface border border-border text-foreground hover:bg-border"
                    >
                        <X className="h-5 w-5" strokeWidth={1.5} />
                    </Button>
                </div>

                {/* Body */}
                <FormSendToSubsidiaries key={resetKey} subsidiaries={subsidiaries} onSubmit={onSubmit} />

                {/* Footer */}
                <div className="bg-card border-t border-border p-5 shrink-0">
                    <SubmitButton
                        form={FORM_SEND_TO_SUBSIDIARIES_ID}
                        className="w-full"
                        isSubmitting={isSubmitting}
                        loadingText={t('account:envoiEnCours')}
                    >
                        {t('account:envoyer')}
                    </SubmitButton>
                </div>
            </SheetContent>
        </Sheet>
    );
}
